import { useQuery } from '@tanstack/react-query';

import { getTeamMemberDetails } from '@/modules/team/api/team.api';

const TEAM_MEMBER_INFO_BEST_EFFORT_QUERY_KEY = 'team-member-info-best-effort';

// Cache so reopening requests from the same member doesn't refetch their details.
const TEAM_MEMBER_INFO_STALE_TIME = 5 * 60 * 1000; // 5 minutes

/**
 * Best-effort fetch of a team member's full details for the approve-mode member
 * card (position + department). Approvers may lack team-read access, so this is
 * deliberately non-fatal: `retry: false` and errors are swallowed by callers —
 * the card simply omits the position/department rows when the data is absent.
 */
export const useTeamMemberInfoBestEffort = (memberId: number | undefined) =>
  useQuery({
    queryKey: [TEAM_MEMBER_INFO_BEST_EFFORT_QUERY_KEY, memberId],
    queryFn: () => getTeamMemberDetails(String(memberId)),
    enabled: memberId != null,
    retry: false,
    staleTime: TEAM_MEMBER_INFO_STALE_TIME,
    // The card is supplementary — don't surface fetch failures.
    throwOnError: false,
  });
